import * as React from 'react';
import * as moment from 'moment';

export default function IncidentUpdate(props) {
    return (
        <div className='row' style={{
            margin: '3px',
            paddingLeft: '10px',
            borderBottom: '1px lightgray solid'
        }}>
            <div className='col-2'><span style={{ fontSize: 16}}>{ moment(props.incident.display_at).format('MMM Do, LT')}</span></div>
            <div className='col-6'><span  style={{ fontSize: 14}}>{ props.incident.body }</span></div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./ui_src/app/components/status/IncidentUpdate.react.jsx